package nl.volleyplanner.api

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

interface ApiEnum {
    val paramValue: String

    companion object {
        inline fun <reified T> fromParamValues(values: Set<String>): Set<T> where T : Enum<T>, T : ApiEnum {
            return enumValues<T>().filter { values.contains(it.paramValue) }.toSet()
        }
    }
}


/**
 * Defines which extra person-related data can be requested via /person/list include=...
 */
@Serializable
enum class PersonInclude(override val paramValue: String) : ApiEnum {
    @SerialName("volunteerJobs")
    VolunteerJobs("volunteerJobs"),
    @SerialName("groups")
    Groups("groups")
}

/**
 * Defines supported group types that can be requested via groups query param or other endpoints.
 * Values should match the server-side Group.typeName values.
 *
 * TODO: Need to align this with entity group types. Currently defined in two places, risk that this breaks if renamed
 */
@Serializable
enum class GroupType(override val paramValue: String) : ApiEnum {
    @SerialName("Team")
    Team("Team"),

    @SerialName("Scheidsrechters")
    Scheidsrechters("Scheidsrechters")
}
